import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.png';

const Page = styled.div`
  height: 100vh;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fefefe;
  padding: 40px;
  border-radius: 10px;
  margin-left: 20px;
  margin-right: 20px;
  box-shadow: 2px 2px 12px 0px rgba(171, 171, 171, 1);
  max-width: 400px;
`;

const MessageWrapper = styled.div`
  margin-top: 20px;
  color: #333;
`;

const FullScreenMessage = ({ message }) => {
  return (
    <Page>
      <Container>
        <img src={logo} alt={'kursifant logo'} />
        <MessageWrapper>{message}</MessageWrapper>
      </Container>
    </Page>
  );
};

export default FullScreenMessage;
